/**
 * Created by rickborst on 22/02/2017.
 */

import {ActionTypes} from 'store/actions/user';

import User from 'models/user';

const defaultUserState = Object.assign({}, new User());

/**
 * User reducer.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Action payload.
 * @returns {Object} User reducer.
 */
function user (state = defaultUserState, action) {

    switch (action.type) {

        case ActionTypes.UPDATE_USER:
            state = {
                ...action.user
            };
            return state;

        case ActionTypes.UPDATE_USER_HOUSEHOLD_ID:
            state = {
                ...state,
                householdId: action.id,
            };
            return state;


        case ActionTypes.CLEAR_USER:
            state = defaultUserState;
            return state;

        default:
            return state;
    }
}

export default user;


// WEBPACK FOOTER //
// ./src/js/store/reducers/user.js